export const events = [
  {
    id: 'workshop-career-mapping',
    title: 'Career Mapping Workshop',
    date: '2025-01-25',
    time: '10:00 AM - 12:00 PM PST',
    modality: 'Online',
    location: 'Zoom',
    description: 'Join Diana for an interactive workshop where you\'ll create your personalized career trajectory map. Walk away with a clear vision of your next steps and the confidence to pursue them.',
    price: 'Free',
    registrationLink: '#',
    featured: true,
    spotsLeft: 15
  },
  {
    id: 'webinar-wellness',
    title: 'Wellness Wednesday: Mindfulness for STEM Minds',
    date: '2025-02-05',
    time: '12:00 PM - 1:00 PM PST',
    modality: 'Online',
    location: 'Zoom',
    description: 'A lunch-hour session focused on practical mindfulness techniques tailored for analytical minds. Learn simple practices you can integrate into your workday.',
    price: 'Free',
    registrationLink: '#',
    featured: false,
    spotsLeft: 50
  },
  {
    id: 'conference-women-stem',
    title: 'Women in STEM Summit',
    date: '2025-03-15',
    time: '9:00 AM - 5:00 PM PST',
    modality: 'Hybrid',
    location: 'San Francisco, CA + Virtual',
    description: 'A full-day summit celebrating and empowering women in STEAM fields. Keynotes, workshops, networking, and more. Diana will be speaking on "Designing Your Non-Linear Success."',
    price: '$99 Virtual / $249 In-Person',
    registrationLink: '#',
    featured: true,
    spotsLeft: 100
  }
];

export const getNextEvent = () => {
  const now = new Date();
  const upcoming = events
    .filter(e => new Date(e.date) >= now)
    .sort((a, b) => new Date(a.date) - new Date(b.date));
  return upcoming[0] || events[0];
};
